import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef } from "react";
import AnimatedNumber from "../../../../../../base/text/animated-number/index.js";
import * as S from "./styled.js";
const SearcherButtonMobile = /*#__PURE__*/ forwardRef(({ disabled =false , counter , counterText , showCount =true , underButton , grow =false , order , height , variant , children , onClick , buttonVariant ='secondary'  }, ref)=>/*#__PURE__*/ _jsxs(S.SearcherItemButtonMobile, {
        "data-testid": "SearcherButtonMobile",
        className: "searcher-button",
        $variant: variant,
        $grow: grow,
        $order: order,
        children: [
            /*#__PURE__*/ _jsxs(S.SearcherWrapperButtonMobile, {
                type: "submit",
                variant: buttonVariant,
                ref: ref,
                disabled: disabled,
                "data-testid": "SearcherButton",
                height: height,
                onClick: onClick,
                children: [
                    children,
                    typeof counter === 'number' && showCount && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            ' | ',
                            /*#__PURE__*/ _jsxs("span", {
                                children: [
                                    /*#__PURE__*/ _jsx(AnimatedNumber, {
                                        number: counter ?? 0
                                    }),
                                    " ",
                                    counterText
                                ]
                            })
                        ]
                    })
                ]
            }),
            underButton
        ]
    }));
SearcherButtonMobile.displayName = 'SearcherButtonMobile';
export default SearcherButtonMobile;

//# sourceMappingURL=index.js.map